import React from 'react';
import { Outlet } from 'react-router-dom';

import '../../Mobile.css';
function Consultation() {

  return (
    <>
      <Outlet />
    </>
  );
}

export default Consultation